module.exports = __webpack_public_path__ + "img/Phrase Analyser_old.4e39da1f.svg";